var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStories(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    rx: 2,
    fill: "#8E4A06"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.62173 3.59954C9.06214 3.20196 8.39086 2.99212 7.70446 3.00023C7.23379 3.0285 6.77198 3.14072 6.34082 3.33159V8.92659H9.409C9.49942 8.92659 9.58613 8.89067 9.65006 8.82674C9.71399 8.76281 9.74991 8.6761 9.74991 8.58568V3.86545C9.74984 3.81436 9.73828 3.76393 9.71609 3.71791C9.69391 3.67188 9.66166 3.63143 9.62173 3.59954ZM7.04855 5.5175V4.83568H8.884V5.5175H7.04855ZM8.884 6.40932V7.09114H7.04855V6.40932H8.884Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3775 3.59953C2.3377 3.63148 2.30558 3.67196 2.28351 3.71799C2.26144 3.76401 2.24999 3.8144 2.25 3.86544V8.58567C2.25 8.67608 2.28592 8.76279 2.34985 8.82673C2.41378 8.89066 2.50049 8.92658 2.59091 8.92658H5.65909V3.33158C5.22794 3.14071 4.76612 3.02849 4.29545 3.00021C3.60887 2.99234 2.93744 3.20215 2.3775 3.59953V3.59953Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStories);
export default __webpack_public_path__ + "static/media/stories.f5f5f94209b7579148dcfe51a6fed6c7.svg";
export { ForwardRef as ReactComponent };